import React from 'react'
import { Box } from '@workwhile/ui'
import { UserPermissionsHeader } from './UserPermissionsHeader'
import { UserPermissionsFilters } from './UserPermissionsFilters'
import { UserPermissionsTable } from './UserPermissionsTable'

export const UserPermissionsMain = () => {
  return (
    <>
      <UserPermissionsHeader />
      <Box margin={3}>
        <UserPermissionsFilters />
        <UserPermissionsTable />
      </Box>
    </>
  )
}
